import { component } from 'picoapp';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const successMessage = node.querySelector('.js-successMessage');

  const config = JSON.parse(node.dataset.config);
  const { formSelector } = config;

  const initForm = () => {
    const attachToForm = () => {
      window.KlaviyoSubscribe.attachToForms(formSelector, {
        hide_form_on_success: false,
        custom_success_message: true,
        success_message: successMessage,
      });
    };

    if (window.KlaviyoSubscribe) {
      attachToForm();
    } else {
      window.addEventListener('klaviyoSubscribe:loaded', attachToForm);
    }
  };

  const init = () => {
    initForm();
  };

  /**
   * Init
   */
  init();
});
